module.exports = __webpack_public_path__ + "static/media/store.fec2b95d.svg";